import React, {
    useState,
    useEffect
} from 'react';

import { getBasketData} from "../router";

import * as CONSTANTS from "../constants";
import * as UTILS from "../utils";

import HeartIcon from '../svg/heart';
import LoadingIndicator from './loading-indicator';

export default function InstanceBasketSummary(props) {

    const [ticketGroup, setTicketGroup] = useState(null);
    const [ticketsTotal, setTicketsTotal] = useState(null);

    const { data: basketData, isFetching } = getBasketData();

    useEffect(() => {
        if (!basketData || !basketData.tickets) return;

        // Include the primary instance's tickets as well as any paid
        // supplementary/extra events (e.g. a meet & greet), which are
        // booked against their own separate instance ids, so the total
        // shown here reflects everything added during this booking.
        const relevant_instance_ids = [
            CONSTANTS.INSTANCE_ID,
            ...(CONSTANTS.SUPPLEMENTARY_INSTANCES || []),
        ].map(String);

        let tickets = basketData.tickets.filter((ticket) =>
            relevant_instance_ids.includes(String(ticket.instance.id)),
        );
        let tickets_total = UTILS.getTicketsTotal(tickets);

        const grouped_tickets = UTILS.groupTicketsByInstance(tickets);

        setTicketsTotal(tickets_total.toFixed(2));
        setTicketGroup(grouped_tickets[0]);

    }, [basketData]);

    return (
        <div className="instance-basket-summary basket-summary">
            {basketData && basketData.tickets.length && ticketGroup ?
                <>
                    <p className="basket-summary__total">
                        {isFetching && !props.showDonations ? 
                                <LoadingIndicator />
                            :
                                <>
                                    <span>
                                        Total
                                    </span>
                                    <span>{`£${ticketsTotal}`}</span>
                                </>
                        } 
                    </p>
                    {props.showDonations && props.donationsTotal ?
                        <p className="basket-summary__item basket-summary__item--donation">
                            <span>Total donation</span>
                                {props.queriesPending || isFetching ?
                                    <LoadingIndicator />
                                :
                                    <span className='basket-summary__item--total'><HeartIcon /> {`£${props.donationsTotal?.toFixed(2)}`}</span>
                                }
                        </p>
                        :null
                    }
                </>
                :null
            }
        </div>
    );
}